import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)


/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
//静态路由
export const constantRoutes = [
  {
    title: '首页',
    path: '/',
    component: () => import('@/views/index'),
    hidden: true,
    meta: {
      "title": "首页",
    },
  },
  {
    path:'*',
    component:()=>import('@/views/notFound/index.vue')
  },
  {
    name: 'assets',
    path: '/assets',
    component: (resolve) => require(['@/views/assets'], resolve),
    meta: {
      "title": "资产发布信息",
    },
  },
  {
    name: 'trade',
    path: '/trade',
    component: (resolve) => require(['@/views/trade'], resolve),
    meta: {
      "title": "交易哈希信息",
    },
  },
  {
    name: 'block',
    path: '/block',
    component: (resolve) => require(['@/views/block'], resolve),
    meta: {
      "title": "区块高度信息",
    },
  },
  {
    name: 'address',
    path: '/address',
    component: (resolve) => require(['@/views/address'], resolve),
    meta: {
      "title": "用户钱包地址",
    },
  },
]

//https://blog.csdn.net/weixin_45522694/article/details/99548714
//vue-router ≥3.0版本回调形式以及改成promise api的形式了，返回的是一个promise，如果路由地址跳转相同, 且没有捕获到错误，控制台始终会出现如图所示的警告
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router